var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-editor-table-mapper hover-btn-effect flex-centerize"},[_vm._v("Configure your table mapper on the right")])
}
var staticRenderFns = []

export { render, staticRenderFns }